import { Link, useLocation } from 'react-router-dom';
import { cn } from '../../utils/cn';
import { TrendingUp, Map } from 'lucide-react';
import TomoroKitLogo from '../branding/TomoroKitLogo';

interface DashboardNavProps {
  basePath?: string;
  environmentTag?: string;
}

const NAV_ITEMS = [
  { segment: 'positioning', label: 'Personas', icon: Map },
  { segment: 'investors', label: 'Investors', icon: TrendingUp },
];

export function DashboardNav({ basePath = '/dashboard', environmentTag }: DashboardNavProps) {
  const location = useLocation();

  const normalizedBase =
    basePath.endsWith('/') && basePath !== '/' ? basePath.slice(0, -1) : basePath;

  return (
    <nav className="border-b border-[#291B4C]/10 bg-white">
      <div className="max-w-[1400px] mx-auto px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="/TemasekHoldings_logo.svg" 
              alt="Temasek" 
              className="h-8"
            />
            <img
              src="/advancelogo.png"
              alt="Advance"
              className="h-5 ml-3"
            />
          </div>

          {/* Nav Items */}
          <div className="flex items-center gap-2">
            {NAV_ITEMS.map((item) => {
              const path = `${normalizedBase}/${item.segment}`;
              const isActive = location.pathname.startsWith(path);
              const Icon = item.icon;
              return (
                <Link
                  key={path}
                  to={path}
                  className={cn(
                    'px-5 py-2.5 rounded-lg text-sm font-medium tracking-wide',
                    'flex items-center gap-2.5',
                    isActive
                      ? 'bg-[#291B4C] text-white'
                      : 'text-[#291B4C] hover:bg-[#291B4C]/5'
                  )}
                >
                  <Icon className="w-4 h-4" strokeWidth={2} />
                  <span className="hidden lg:inline uppercase tracking-wider text-xs font-semibold">{item.label}</span>
                </Link>
              );
            })}
          </div>

          {/* Right side - Branding */}
          <div className="flex items-center gap-3">
            {environmentTag && (
              <span className="uppercase tracking-wider text-xs font-semibold bg-[#291B4C]/10 text-[#291B4C] px-3 py-1.5 rounded-md">
                {environmentTag}
              </span>
            )}
            {/* Powered by TomoroKit */}
            <div className="flex items-center gap-2 px-3 py-1.5 border border-[#291B4C]/10 rounded-lg">
              <div className="flex flex-col">
                <span className="text-[8px] font-medium text-[#291B4C]/40 uppercase tracking-wider leading-none mb-0.5">
                  Powered by
                </span>
                <TomoroKitLogo 
                  className="h-2.5 text-[#291B4C]" 
                  style={{ '--tomoro': '#291B4C', '--kit': '#291B4C', '--kit-opacity': '0.3' } as React.CSSProperties}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
}
